export default __webpack_public_path__ + "static/media/something-error-img.cc63a422.jpg";